import React, { Component } from 'react';

import Row from '../../components/row';
import Panel from '../../components/panel';
import Email from '../../components/email';
import Phonenumber from '../../components/phonenumber';
import PageTitle from '../../components/page-title';
import OpeningHours from '../../components/opening-hours';
import Icon from '../../components/icon';
import IconSchedule from '../../components/icons/schedule';

import './contact.css';

import { connect } from 'react-redux';

class Contact extends Component {
	dispatch = this.props.dispatch;

	render() {
		const { translations, labels } = this.props;
		return (
			<div className="view-contact">
				<Row>
					<PageTitle>{translations.title}</PageTitle>
				</Row>
				<Row>
					<div className="contact-info">
						{labels.info.phone_number && (
							<Panel
								name="label-contact"
								additionalClass="label-contact"
								topBorder={true}
								title={translations.form.customerServiceTitle}>
								{labels.info.email && (
									<Email>
										<a
											className="primary-text-color"
											href={`mailto:${labels.info.email}`}>
											{labels.info.email}
										</a>
									</Email>
								)}
								<div className="number-and-time">
									{labels.info.phone_number && (
										<Phonenumber
											phone_number={labels.info.phone_number}
											isLink={true}
										/>
									)}
									{labels.info.opening_hours.length > 0 && (
										<div className="time">
											<Icon icon={IconSchedule} size="inline" />
											<OpeningHours
												opening_hours={labels.info.opening_hours}
												translations={translations}
											/>
										</div>
									)}
								</div>
							</Panel>
						)}
					</div>
				</Row>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		ui: state.ui.contact,
		relations: state.data.relations,
		labels: state.data.labels,
		translations: Object.assign(
			state.translations.contact,
			state.translations.general
		),
	};
}

export default connect(mapStateToProps)(Contact);
